/////////////////////////////////////////////////V5CommentStart
// myLocationInfo march 1
// Sunmar8
// Mar14, more docs
// mar 15 URL doing ok for myvehiclefilters
// mar23 doing use case 1 and 2 pretty good
// 2021-03-16 - Cleanup  THERE WAS ALOT OF COMMENTED CODE PRIOR TO THIS maybe need to go back
// 2021-05-27 - merged stuff
// 2022-12-20  DEC22ZIPFIX tag  - added clientip retrieval
// 2023-01-23  Blogview stuff
// 2023-01-28  Blogview tidied up
// 2023-03-05  tidy up - scriptag moved out
/////////////////////////////////////////////////V5CommentEnd

import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
  Redirect,
} from 'react-router-dom'
import {
  Grid,
  Row,
  Col,
  Navbar,
  Nav,
  NavDropdown,
  Image,
  Modal,
} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import queryString from 'query-string'

import CookieConsent from 'react-cookie-consent' //ddfallcookie

// Main content components
import Detroit from './components/Detroit'
import FrontPage from './components/FrontPage'
import DataView from './components/DataView'
import Financing from './components/Financing'
import Services from './components/Services'
import Legal from './components/Legal'
import Privacy from './components/Privacy'
import ContactUs from './components/ContactUs'
import Apply from './components/Apply'
import Featured from './components/Featured'
import ScrollToTop from './components/ScrollToTop'
import CFLink from './components/CFLink'

//DDBLOGWORK
import BlogView from './components/BlogView'
import BlogViewer from './components/BlogView'

// Custom components
import NavItemLink from './components/NavItemLink'
import MenuItemLink from './components/MenuItemLink'
import SearchAreaForm from './components/SearchAreaForm'
//import SocialLinks from './components/SocialLinks'

// Geolocation Utilities
import {
  getClientIP,
  getLocationFromIP,
  getLocationFromZipCode,
} from './utils/location'
// CSS and assets
import './App.css'
import logo from './images/logo.png'
import logoWhite from './images/logo-white.png'

const copyright = (
  <span className="copyright">
    Copyright &copy; {new Date().getFullYear()} CarFinder.com LLC. All rights
    reserved. Release20240122
  </span>
)

const VERSION = '1.9' // +new Date() // TODO dev only

// https://stackoverflow.com/questions/7042611/override-console-log-for-production

var CFDconsole = (function(oldCons) {
  var CFDebugOn = true

  return {
    log: function(text) {
      if (text.toString().slice(0, 3) == 'CFD') {
        if (CFDebugOn) oldCons.log('CF BEBUG MODE-' + text)
      } else oldCons.log('CFLogger-' + text)
      // Your code
    },
    info: function(text) {
      oldCons.info(text)
      // Your code
    },
    warn: function(text) {
      oldCons.warn(text)
      // Your code
    },
    error: function(text) {
      oldCons.error(text)
      // Your code
    },
  }
})(window.console)

//Then redefine the old console
window.console = CFDconsole

//---------------------------------------
// How to confirm this is the starting point ?
//---------------------------------------
class App extends React.Component {
  //---------------------------------------
  // Constructor
  //
  //---------------------------------------
  constructor(props) {
    console.log(`CFD_FUNC_APP_constructor:`)
    super(props)

    // *************************************
    // TESTMODE - rather than folling with debugger
    //  http://localhost:3000/test?MODE=CLEAR
    // *************************************
    this.myMode = queryString.parse(props.location.search)
    if (this.myMode.MODE === 'CLEAR') localStorage.clear()

    // *************************************
    // LOCAL STORAGE CHECK
    // *************************************
    // if local cache wiped, set defaults,
    // check for URL over ride later, valid the hell URL/vs local
    // can only get IP / external stuff in componentdidmount or other functions
    const version = localStorage.getItem('version')

    if (version !== VERSION) {
      localStorage.clear()
      localStorage.setItem('version', VERSION)
      console.log(`CFD: App 0: setting fresh version to  local`)
    } else {
      console.log(`CFD: App 0: Version is ok, not reseting`)
    }

    // *************************************
    // URL processing - get values
    // *************************************
    // Check the URL, take the URL over state
    // use temp variable to push to structures, which may be empty WASFROMURL is a simple flag to check
    // URL has all or nothing - !!!NOT !!! doing overload URL structure onto old state if URL structures are not empty, we
    // ? For convenience, but need to see if all props are there if new time
    // ? need to see if persisted state zip code is different,
    // ?double check all
    // ?revive previous app state or set defaults (and persist state)
    // ?this.tempSearch = queryString.parse(props.location.search)

    this.search = queryString.parse(props.location.search)
    const {
      price,
      year,
      mileage,
      bodies,
      fuels,
      models,
      WASFROMURL,
      zipCode,
      radius,
      ipp,
      sort,
      page,
    } = this.search
    this.myVehicleFiltersFromURL = {
      price,
      year,
      mileage,
      bodies,
      fuels,
      models,
      WASFROMURL,
    }
    this.myBasicParamsFromURL = { zipCode, radius, ipp, sort, page, WASFROMURL }
    //DDFIX - what about myLocationInfo - that may not be in sync with local storage

    if (price || year || mileage || bodies || fuels || models)
      this.myVehicleFiltersFromURL.WASFROMURL = true
    else this.myVehicleFiltersFromURL.WASFROMURL = false

    if (zipCode || radius || ipp || sort || page)
      this.myBasicParamsFromURL.WASFROMURL = true
    else this.myBasicParamsFromURL.WASFROMURL = false

    // *************************************
    // prep this.state
    // *************************************
    // Get the Local State
    this.state = {}
    try {
      this.state = JSON.parse(localStorage.getItem('state'))
      console.log(`CFD: App 1: getting old state`)
    } catch (err) {
      localStorage.removeItem('state') // corrupted, so remove
    }
    if (!this.state) {
      this.state = {
        //FATHEAD: 'InConstructorXyz',
        savedCars: [],
        myLocationInfo: {},
        myVehicleFilters: {},
        myBasicParams: {},
      } // ...this.state,
    }

    // *************************************
    // if anything came in on the URL, assume you need to wipe out all local storage
    // but you need to tip toe around myLocationInfo
    // otherwise set the defaults
    // *************************************

    if (
      this.myVehicleFiltersFromURL.WASFROMURL ||
      this.myBasicParamsFromURL.WASFROMURL
    ) {
      // *************************************
      // Process myBasicParams
      // this.state now has localStorage version of state
      // assume if they wanted the param it would be on the
      // *************************************
      this.state.myVehicleFilters = {}
      this.state.myBasicParams = {}
      this.state.myVehicleFilters = this.myVehicleFiltersFromURL
      this.state.myBasicParams = this.myBasicParamsFromURL

      // Reset myLocationInfo if the zip doesnt match the one in the URL
      // not the most elegant location
      if (
        this.myBasicParamsFromURL.zipCode &&
        !(
          this.myBasicParamsFromURL.zipCode == this.state.myLocationInfo.zipCode
        )
      ) {
        console.log(`CFD wiping out location info`)
        this.state.myLocationInfo = {}
        this.state.myLocationInfo.zipCode = this.myBasicParamsFromURL.zipCode
      }
    } else {
      // something came in on the URL
      //noURL params

      // IF ZIP in URL is different, wipe out mylocation info, keep the other filters
      // if myBasicParamsFromURL are dfferent  push those values to state
      // ? when do we remove vehicle filters?
      // ? can we get zip/vehicle filters from detroit

      this.myBasicParamsFromLocal = {}

      if (this.state && this.state.myBasicParams.radius)
        this.myBasicParamsFromLocal = this.state.myBasicParams
      else {
        //DDFIX
        //this.myBasicParamsFromURL ={  zipCode, radius, ipp, sort, page, WASFROMURL}
        //radius: radius >= 25000 ? 100 : `${radius}`,
        //nationwide: radius >= 25000,
        this.myBasicParamsFromLocal = {
          //  BOOGERFACE: 'WASDEFAULTSFROMConstructor' ,
          zipCode,
          nationwide: false,
          radius: 30,
          ipp: 10,
          sort: '+CDISTANCE',
          page: 1,
        }
      }
      //ddfix, confirm this is needed
      this.state.myBasicParams = this.myBasicParamsFromLocal

      /* DDFUX..is this needed
      // *************************************
      // Overload state with URL values if present 
      // *************************************
      // use command since commneted one below doesnt push correct it will push to wrong level
      if ( this.myVehicleFiltersFromURL.WASFROMURL)
      this.state.myVehicleFilters=this.myVehicleFiltersFromURL
      //...this.myVehicleFiltersFromURL,

      // todo Reset mBasicParams off uRL if they dont match
      //probably do 1 by 1 rather than this chunk
      if ( this.myBasicParamsFromURL.WASFROMURL)
        this.state.myBasicParams=this.myBasicParamsFromURL
      else 
      this.state.myBasicParams=this.myBasicParamsFromLocal

      //NEWSTUFF above     
    */
    } // end else no URL
    ///////////////////////////////////////////////////////////////////

    // *************************************
    //   Persist your final values
    // *************************************
    console.log(`CFD: App 3: setting local`)
    localStorage.setItem('state', JSON.stringify(this.state))

    // For redirects
    this.previousLocation = null

    // *************************************
    //   Handle the SAS
    //   only meaningful if the local had something and IF there was a URL,
    //   and that the URL zipcode agreed with it.
    //   otherwise the mylocationinfo.Zipcode will be null
    //   need to set mylocatioinfo and the SAS after the zip is derived by IP
    // *************************************
    this.searchAreaSupplemental = {}

    if (this.state.myLocationInfo.zipCode) {
      // damon added the condition
      console.log(
        `CFDc: App 4a: setting local`,
        this.state.myLocationInfo.zipCode
      )
      // if you have a zip, then thats good enough
      // this.setSearchAreaSupplemental(this.state.myLocationInfo.zipCode)
      this.searchAreaSupplemental = this.state.myLocationInfo
      console.log(
        `CFDc: App 4b: setting local`,
        this.searchAreaSupplemental.zipCode
      )
    }
  } // end constructor

  //---------------------------------------
  // just checks if Zip and Radius were passed in, validates digits
  // Ignores if radius not passed in (? is that ok)
  //---------------------------------------
  validateSearchArea({ radius, zipCode } = this.search) {
    console.log(`CFD_FUNC_APP_validateSearchArea:`)
    return (
      zipCode &&
      zipCode.match(/^\d{5}$/) &&
      (!('radius' in this.search) || radius.match(/\d+$/))
    )
  } // end validateSearchArea

  //---------------------------------------
  // Comes into play when clicking around from 1st page to featured
  //---------------------------------------
  componentWillReceiveProps(props) {
    console.log(`CFD_FUNC_APP_componentWillReceiveProps:`)
    // For convenience
    this.search = queryString.parse(props.location.search)

    // search area required only in these paths
    if (props.location.pathname.match(/^\/(inventory|dealers)$/)) {
      // validate new search area and sync state
      // NOTE: invalid search area will be handled with a redirect in router

      if (this.validateSearchArea(this.search)) {
        // pattern match and confirms zip is there, radius optional
        // *************************************
        // Processing changes to Search ZIP/Radius
        // *************************************

        const { radius, zipCode } = this.search
        if (
          zipCode == this.state.myLocationInfo.zipCode &&
          radius == this.state.myBasicParams.radius
        ) {
          // if my local copy (myLocationInfo matches the search area )
          console.log(
            `CFD_FUNC_APP_componentWillReceiveProps2: SAME ZIP and Radius`
          )
          if (this.searchAreaSupplemental.zipCode != zipCode) {
            // supplemental out of whck
            ///this.setSearchAreaSupplemental()
            this.setAllTheLocalState(
              this.state.myLocationInfo,
              radius,
              'InProps1'
            )
          }
          // else all caches were already in sync (maybe)
        } else {
          // end search didnt change
          //  need to redo mysearch are and mysearch supplemental
          console.log(
            `CFD_FUNC_APP_componentWillReceiveProps2: changing ZIP and Radius`
          )
          const myLocationInfo = { radius, zipCode }
          // wtf when is this not null...?
          if (!myLocationInfo.radius) {
            delete myLocationInfo.radius
          }
          this.searchAreaSupplemental = {}
          //setSAS is getting data from getlocfromzip(zip)
          //if that result ZIP <> mysearchZIP then set SAS to result
          // why do we wait to set state of myLocationInfo here
          console.log(`CFD: App 1x: before setSAS `)
          //this.setState({ myLocationInfo }, () => this.setSearchAreaSupplemental())
          this.setSearchAreaSupplemental(zipCode, radius)
          console.log(`CFD: App 1z: after setSAS `)
        }
        // *************************************
        // Processing changes to vehicle filters, URL already has the right stuff, just need to set local ones
        // *************************************

        const {
          price,
          year,
          mileage,
          bodies,
          fuels,
          models,
          WASFROMURL,
          ipp,
          sort,
          page,
        } = this.search // zipCode, dupe radius,
        this.myBasicParamsTemp = {
          zipCode,
          radius,
          ipp,
          sort,
          page,
          WASFROMURL,
        }
        this.myVehicleFiltersTemp = {
          price,
          year,
          mileage,
          bodies,
          fuels,
          models,
        }
        var tempstate = JSON.parse(localStorage.getItem('state'))

        tempstate.myVehicleFilters = this.myVehicleFiltersTemp
        tempstate.myBasicParams = this.myBasicParamsTemp

        this.setState({ myVehicleFilters: tempstate.myVehicleFilters }) // this.setState({ state: tempstate });//this.state=tempstate
        this.setState({ myBasicParams: tempstate.myBasicParams }) // this.setState({ state: tempstate });//this.state=tempstate
      } // passed validate search
    } // path is inv or dealers
  } // end componentWillRecievePorps

  //---------------------------------------
  // make this if the there is a need to refresh ip from zip, dont think we wont ever NOT have a zip
  // local/SAS/state/search are juggled and set here.
  //---------------------------------------
  setSearchAreaSupplemental = (zipCode, radius) => {
    console.log(`CFD_FUNC_APP_setSearchAreaSupplemental:`)

    //const { zipCode } = this.state.myLocationInfo
    // what is this returning?
    // then why setting again
    // variables are bit squishy
    return getLocationFromZipCode({ zipCode })
      .then(result => {
        this.searchAreaSupplemental = result
        this.setAllTheLocalState(
          this.searchAreaSupplemental,
          radius,
          'InSetSAS3'
        )
        {
        }
      })
      .catch(err => {
        console.log('CFD_FUNC_APP ERROR CAUGHT  ' + err.message)
        return
      })
  } // end setSAS

  //---------------------------------------
  // IS THIS OK? Seems odd
  //---------------------------------------
  componentWillUpdate(props) {
    console.log(`CFD_FUNC_APP_componentWillUpdate:`)
    if (
      !this.state.myLocationInfo.zipCode &&
      props.location.pathname.match(/^\/(dealers|inventory)$/)
    ) {
      // There could be a redirection to searchArea, so set previousLocation
      // breadcrumb to return user to previous page if they cancel the
      // redirect modal. See:
      //
      // - https://reacttraining.com/react-router/web/example/modal-gallery
      //
      // - <Switch> and the <Modal>s in App.render() for related components
      const { state = {} } = props.location
      if (
        state.modal &&
        state.modal !== 'searchArea' &&
        props.history.action !== 'POP'
      ) {
        this.previousLocation = this.props.location
      }
    } // zipcode is good?
  } // componentWillUpdate

  //---------------------------------------
  //DEC22ZIPFIX  - got client IP first - lots of work
  //---------------------------------------
  componentDidMount() {
    // Most operations are dependent on search area. As a convenience,
    // preset the search area based on the client IP.
    //
    // Note: There are multiple events that reset search area: via query
    // string parameter (App.componentWillReceiveProps()), a missing zipCode
    // redirect (in DataView), the "change search area" (in DataView.Inventory and
    // DataView.Dealers), or entering a new zipCode in the Detroit UI widget.
    console.log(`CFD_FUNC_APP_componentDidMount:`)
    if (!this.state.myLocationInfo.zipCode) {
      //nozip found block
      this.searchAreaSupplemental = {}

      getClientIP().then(
        getClientIP_result => {
          // promise action getClientIP
          console.log(
            `CFD_FUNC_APP_ CMD first then 1: here is getClientIP_result ` +
              getClientIP_result
          )
          console.log(
            `CFD_FUNC_APP_CMD first then 2: ` + getClientIP_result.IPv4
          )
          //       aaa = getClientIP_result.IPv4
          {
            //knicknock
            console.log(
              `CFD_FUNC_APP_ CMD first then 3: ` + getClientIP_result.IPv4
            )

            ///-------------------------------------------------
            //  GET PROMISE FROM FUNCTION
            ///-------------------------------------------------

            //getLocationFromIP('192.206.151.131')  // canada test
            //getLocationFromIP('6ssssss66.175')  // bad data test
            //getLocationFromIP('67.243.66.175')  // kingston ny test

            getLocationFromIP(getClientIP_result.IPv4) // goodone
              .then(
                // promise action getLocationFromIP
                // process returned location coords into state variales
                myLocationInfo => {
                  // Async race condition, so don't clobber manual setting.
                  ///-------------------------------------------------
                  this.setState(state => {
                    //using setting state function... do not understand why in this block  //DDFIX
                    // Skipped on first pass with no state,

                    // if newzip via IP differs, SAS gets the new values, do we change any of the other blocks in state
                    if (state.myLocationInfo.zipCode) {
                      if (
                        myLocationInfo.zipCode == state.myLocationInfo.zipCode
                      ) {
                        this.searchAreaSupplemental = myLocationInfo
                        this.searchAreaSupplemental.zipCode =
                          state.myLocationInfo.zipCode
                        this.searchAreaSupplemental.MAXWELLSMART = 'true' //DDFIX... really?
                      }
                      return {}
                      // DDFIX wtf on this return ? does this mess up everything
                    }
                    this.searchAreaSupplemental = myLocationInfo
                    console.log(
                      `CFD: App end of compoent did mountzzz: setting local`
                    )
                    //new monday, is this ok?
                    this.state.myLocationInfo = myLocationInfo
                    // we dont have this on the first pass. you just got the zip code  DDTEMPFIX
                    this.state.myBasicParams.zipCode = myLocationInfo.zipCode

                    // use setState?this.setState((myLocationInfo, props)
                    localStorage.setItem('state', JSON.stringify(this.state))

                    return { myLocationInfo }
                  }) // end using setting state function...
                  ///-------------------------------------------------
                }
              ) // promise action getLocationFromIP
              .catch(err => {
                console.log(
                  'CFD_FUNC_APP Error Handler processing getLocationFromIP------------------------ ' +
                    err
                )
              })
            console.log(`CFD_FUNC_APP_ComponentDidmount- check ehere:`)
          } //knicknock
        } // promise action getClientIP
      )
    } //nozip found block
  } // end componentDidMount

  //---------------------------------------
  //
  //---------------------------------------
  componentDidUpdate() {
    // Persist state on each update
    const { ...state } = this.state
    localStorage.setItem('state', JSON.stringify(state))
  }

  // TODO
  // handleSelect = key => {
  //   // New cars menu-item is a special case (launches Detroit widget)
  //   if (key === 1) {
  //     this.setState({ showQuoteModal: true })
  //   }
  //   // TODO track click
  // }

  //---------------------------------------
  //DDFIX.
  //---------------------------------------
  getSavedCars = () => [...this.state.savedCars]
  //---------------------------------------
  //
  //---------------------------------------
  savedCarsToggle = vin => {
    console.log(`CFD_FUNC_APP_savedCarsToggle:`)
    this.setState((prevstate, props) => {
      // First, try to "toggle-off" the vin (by filtering)
      let savedCars = prevstate.savedCars.filter(v => v !== vin)

      // if the filtered list and the orginal are the same length, then
      // the vin was not in the original list and need to be "toggled on"
      if (savedCars.length === prevstate.savedCars.length) {
        savedCars = [...savedCars, vin]
      }
      return { savedCars }
    })
  }

  //---------------------------------------
  //
  //---------------------------------------
  isSavedCar = vin => {
    console.log(`CFD_FUNC_APP_isSavedCar:`)
    return this.state.savedCars.filter(el => el === vin).length > 0
  } //end

  //---------------------------------------
  //
  //---------------------------------------
  handleAbortSearchAreaChange = () => {
    console.log(`CFD_FUNC_APP_handleAbortSearchAreaChange:`)
    if (this.previousLocation) {
      this.props.history.goBack()
    } else {
      this.props.history.push({ pathname: '/', search: '?' })
    }
  } //end

  // TODO
  // handleHideQuoteModal = () => {
  //   this.setState({ showQuoteModal: false })
  // }

  //---------------------------------------
  //
  //---------------------------------------
  searchAreaRedirect = props => {
    console.log(`CFD_FUNC_APP_searchAreaRedirect:`)
    if (this.redirect) return null
    if (this.validateSearchArea(this.search)) return null

    const { location } = this.props
    let search = { ...this.search }
    const { myLocationInfo, myBasicParams, myVehicleFilters } = this.state
    if (myLocationInfo.zipCode) {
      // use currently active myLocationInfo to fix invalid search area
      const {
        zipCode,
        radius,
        ipp,
        sort,
        page,
        price,
        year,
        mileage,
        bodies,
        fuels,
        models,
      } = {
        ...myLocationInfo,
        ...myBasicParams,
        ...myVehicleFilters,
        ...this.searchAreaSupplemental,
      }

      search =
        '?' +
        queryString.stringify({
          zipCode,
          radius,
          ipp,
          sort,
          page: 1,

          price,
          year,
          mileage,
          bodies,
          fuels,
          models,
          ...search,
        })
      this.redirect = true
      return <Redirect to={{ ...location, search }} />
    }

    // redirect to open search-area modal
    // only reached when the get-location service isn't available
    let { state = {} } = props.location
    if (state.modal !== 'searchArea') {
      state = { ...state, modal: 'searchArea' }
      delete search.zipCode
      delete search.radius
      search = '?' + queryString.stringify(search)
      this.redirect = true
      return <Redirect to={{ ...location, search, state }} />
    }

    // safety
    return null
  } // end searchAreaRedirect

  //---------------------------------------
  //
  //---------------------------------------
  pagerRedirect = props => {
    if (this.redirect) return null
    const { location } = this.props
    let search = { ...this.search }
    if (
      !(
        'page' in search &&
        search.page.match(/^\d+$/) &&
        parseInt(search.page, 10) > 0
      )
    ) {
      this.redirect = true
      search.page = '1'
    }
    if (
      !(
        'ipp' in search &&
        search.ipp.match(/^\d+$/) &&
        parseInt(search.ipp, 10) > 0
      )
    ) {
      this.redirect = true
      search.ipp = localStorage.getItem('ipp') || '10'
    }
    if (this.redirect) {
      search = '?' + queryString.stringify(search)
      return <Redirect to={{ ...location, search }} />
    }
    return null
  } // end pager redirect

 
  //---------------------------------------
  render() {
    console.log(`CFD_FUNC_APP_render:`)
    const { savedCars } = this.state
    const { state = {} } = this.props.location
    this.redirect = false

    return (
      <div className="App">

       
        <Grid fluid componentClass="header" className="App-header">
          <Navbar
            fluid
            collapseOnSelect
            fixedTop={true}
            onSelect={this.handleSelect}
          >
            <Navbar.Header>
              <Navbar.Brand>
                <h1 className="App-title">Carfinder.com</h1>

                <CFLink to="/" exact>
                  <Image
                    responsive
                    src={logo}
                    className="App-logo"
                    alt="carfinder logo"
                  />
                </CFLink>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav pullRight>
              <MenuItemLink eventKey={6} to="/research">
                  Research
                </MenuItemLink>


                <MenuItemLink eventKey={1} to="/newfinder">
                  New Car Deals
                </MenuItemLink>

                <MenuItemLink eventKey={1} to="/usedfinder">
                  Used Car Deals
                </MenuItemLink>

                <NavItemLink eventKey={2} to="/inventory?cond=used">
                  Search Inventory
                </NavItemLink>
                <NavItemLink eventKey={3} to="/dealers">
                  Find A Dealer
                </NavItemLink>
                <NavDropdown eventKey={4} title="Services" id="nav-dropdown-2">
                  <MenuItemLink eventKey={4.1} to="/financing">
                    Financing
                  </MenuItemLink>
                  <MenuItemLink eventKey={4.2} to="/services">
                    Services
                  </MenuItemLink>
                </NavDropdown>
                <NavItemLink
                  eventKey={5}
                  to={'/inventory/saved-cars'}
                  disabled={savedCars.length === 0}
                >
                  <FontAwesome
                    name={savedCars.length === 0 ? 'heart-o' : 'heart'}
                    style={{ color: 'red' }}
                  />{' '}
                  <span>{savedCars.length}</span>
                </NavItemLink>
                {/* TODO 
                <NavItemLink eventKey={6} to="/account">
                  <FontAwesome name="user" />
                </NavItemLink>
                */}
              </Nav>
              <CookieConsent
                location="bottom"
                buttonText="I accept"
                cookieName="myAwesomeCookieName2"
                style={{ background: '#2B373B' }}
                buttonStyle={{ color: '#4e503b', fontSize: '13px' }}
                expires={150}
                // enableDeclineButton
                onDecline={() => {
                  alert('nay!')
                  //resetCookieConsentValue();
                }}
              >
                This website uses cookies to enhance the user experience. By
                continuing to browse the site, you accept cookies. Please read
                our privacy statement for details{' '}
                <span style={{ fontSize: '10px' }}></span>
              </CookieConsent>
            </Navbar.Collapse>
          </Navbar>
        </Grid>
        <Grid fluid componentClass="main" className="main-content">


      {/* trying to not use research exact
      
              <Route
            path="/(research)"
            render={this.searchAreaRedirect}
          />


      */}

      {/* not sure why it needs SAR */}

        <Route
            path="/(research)"
            render={this.searchAreaRedirect}
          />




          <Route
            exact   
            path="/(inventory|dealers)"
            render={this.searchAreaRedirect}
          />




          <Route
            exact
            path="/(inventory|dealers|research)"
            render={this.pagerRedirect}
          />
          <Route
            exact
            path="/inventory/saved-cars"
            render={this.pagerRedirect}
          />
          <Route
            exact
            path="/dealers/:did/inventory"
            render={this.pagerRedirect}
          />
          <Switch
            location={
              state.modal && state.modal.searchArea
                ? this.previousLocation || { pathname: '/' }
                : this.props.location
            }
          >
            <Route
              exact
              path="/newfinder"
              render={props => (
                <Detroit {...props} widget="NEWDEAL" app={this} />
              )}
            />
 


            <Route
              exact
              path="/usedfinder"
              render={props => <Detroit {...props} app={this} />}
            />

            <Route
              exact
              path="/inventory/(saved-cars)"
              render={props => (
                <DataView.Inventory.Saved {...props} app={this} />
              )}
            />
            <Route
              exact
              path="/inventory/:vin([a-zA-Z0-9]{17})"
              render={props => (
                <DataView.Inventory.Detail {...props} app={this} />
              )}
            />
            <Route
              exact
              path="/dealers/:did/(inventory)"
              render={props => <DataView.Inventory {...props} app={this} />}
            />
            <Route
              exact
              path="/inventory"
              render={props => (
                <DataView.Inventory
                  {...props}
                  {...this.state.myLocationInfo}
                  app={this}
                />
              )}
            />
            <Route
              exact
              path="/dealers/:did"
              render={props => (
                <DataView.Dealers.Detail {...props} app={this} />
              )}
            />
            <Route
              exact
              path="/dealers"
              render={props => (
                <DataView.Dealers
                  {...props}
                  {...this.state.myLocationInfo}
                  app={this}
                />
              )}
            />
       



      
       <Route  
              path="/research"
              render={props => (
                <BlogView.Asshole
                  {...props}
                  {...this.state.myLocationInfo}
                  app={this}
                />
              )}
            />
          
          {/*  DDSUNDAY
          NOTE: exact removed 
            somehow, we dont need inventory above, fix this        

                      
                

            <Route  
              path="/research"
              render={props => (
                <BlogViewer
                  {...props}
                  {...this.state.myLocationInfo}
                  app={this}
                />
              )}
            />


*/}

 

            <Route
              exact
              path="/"
              render={props => (
                <FrontPage
                  {...props}
                  myLocationInfo={this.state.myLocationInfo}
                  app={this}
                />
              )}
            />
            <Route path="/financing" render={Financing} />
            <Route path="/services" render={Services} />
            <Route path="/legal" render={Legal} />
            <Route path="/privacy" render={Privacy} />
            <Route path="/contact" render={ContactUs} />
            <Route path="/apply" render={Apply} />
            <Route
              path="/featured/:section"
              render={props => <Featured {...props} />}
            />
            <Route
              render={props => (
                <p className="error">
                  Page not found: {this.props.location.pathname}
                  {this.props.location.search}
                </p>
              )}
            />
          </Switch>
        </Grid>
        <Grid fluid componentClass="footer" className="App-footer">
          <Row className="content">
            <Col className="logo" md={6} xs={12}>
              <Image
                responsive
                src={logoWhite}
                className="App-logo"
                alt="logo"
              />
            </Col>
            <Col md={6} xs={12}>
              <h2>Our Company</h2>
              <Nav stacked activeKey={1} onSelect={() => {}}>
                <NavItemLink eventKey={1} to="/apply">
                  Become a Dealer
                </NavItemLink>
                <NavItemLink eventKey={2} to="/legal">
                  Terms of Use
                </NavItemLink>
                <NavItemLink eventKey={2} to="/privacy">
                  Privacy Statement
                </NavItemLink>
                <NavItemLink eventKey={3} to="/contact">
                  Contact Us
                </NavItemLink>
              </Nav>
            </Col>
          </Row>
          <Row className="copyright">
            <Col xs={12} style={{ textAlign: 'center' }}>
              {copyright}
            </Col>
          </Row>
          <Modal
            className="MainModal"
            show={state.modal && state.modal.searchArea}
            onHide={this.handleAbortSearchAreaChange}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Please provide your location so we can localize your search
                results
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Route component={SearchAreaForm} />
            </Modal.Body>
          </Modal>
        </Grid>
      </div>
    )
  } /// ? end render?

  //---------------------------------------
  // make this if the there is a need to refresh all location inf from zip, dont think we wont ever NOT have a zip
  // local/SAS/state/search are juggled and set here.
  // basically myLocationInfo needs to be in local/SAS/state and
  //      zip/radius needs to be in mySearchParams section of local/SAS/state & search

  //---------------------------------------
  setAllTheLocalState = (newLocationInfo, newRadius, whereami) => {
    console.log(`CFD_FUNC_APP_setAllTheLocalState:`, newLocationInfo, whereami)
    //    const  { radius, zipCode, latitude, longitude} = newParams ;

    //this.search = queryString.parse(props.location.search)
    //const  {price, year,  mileage,  bodies, models, zipCode, radius, ipp, sort, page} =newLocationInfo;
    const { zipCode, latitude, longitude, city, state } = newLocationInfo

    // Theory:
    // assume ZIPCODE is passed in and running promise is cpu/time and api $ costs are more expensive than checking
    // run checks and updates if zip(and associated myLocationInfo) or radius
    // - not sure why lat/long are needed

    // get copy of local for comparison

    var needToSetLocal = false
    // *****************************************************************
    // Step1 - check 2 params against state,  assume if local/state/SAS
    //      if ZIP, run the function, push to local supercopy
    //            - Then update state/SAS/local/search(url)
    //      check Radius
    // *****************************************************************
    if (zipCode == this.state.myLocationInfo.zipCode) {
      console.log(
        `CFD: App setAllTheLocalState: Set this.state.myLocationInfo.zipCode FALSE`
      )
    } else {
      // state is bad, reset it
      console.log(
        `CFD: App setAllTheLocalState: Set this.state.myLocationInfo.zipCode TRUE`
      )
      this.state.myLocationInfo = newLocationInfo
      // this.state.myLocationInfo.FUNKY='WipeOutinSAF'
      needToSetLocal = true
    }

    if (newRadius == this.state.myBasicParams.radius) {
      // state is same, leave it check the rest
      console.log(
        `CFD: App setAllTheLocalState: Set this.state.myBasicParams.radius FALSE`
      )
    } else {
      // state is bad, reset it
      console.log(
        `CFD: App setAllTheLocalState: Set this.state.myBasicParams.radius TRUE`
      )
      // this.state.myBasicParams.BOOGERFACE='WipeOutinSAF_2'
      this.state.myBasicParams.radius = newRadius
      needToSetLocal = true
    }
    if (zipCode == this.state.myBasicParams.zipCode) {
      // state is same, leave it check the rest
      console.log(
        `CFD: App setAllTheLocalState: Set this.state.myBasicParams.zipCode FALSE`
      )
    } else {
      // state is bad, reset it
      console.log(
        `CFD: App setAllTheLocalState: Set this.state.myBasicParams.zipCode TRUE`
      )
      // this.state.myBasicParams.BOOGERFACE='WipeOutinSAF_2'
      this.state.myBasicParams.zipCode = zipCode
      needToSetLocal = true
    }

    if (needToSetLocal) {
      //this.state.FATHEAD='WipeOutinSAF_3'
      localStorage.setItem('state', JSON.stringify(this.state))
      console.log(
        `CFD: App setAllTheLocalState: Setting LOCAL STORAGE`,
        this.state
      )
    }
  }
} // end ClassApp

//---------------------------------------
//
//---------------------------------------
export default function() {
  return (
    <Router className="App">
      <ScrollToTop>
        <Route render={props => <App {...props} />} />
      </ScrollToTop>
    </Router>
  )
}



// WEBPACK FOOTER //
// ./src/App.js